// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NavigationItem_NavigationItem__9v4K0","active":"NavigationItem_active__-tc3V"};